import { Button } from '@gto/ui/button'
import { ArrowPathIcon } from '@gto/ui/icons/solid'

import {
  type DataTableStateCopy,
  DEFAULT_LOAD_MORE_ERROR_MESSAGE,
  DEFAULT_RETRY_LABEL,
} from './state-overlay'

/**
 * Bottom-of-list inline retry for a failed next-page fetch — replaces the analyze
 * table's silent `catch(console.error)` (`no-silent-failures`), `loadMoreError` stays
 * inspectable. Rendered after the last row inside the scroll flow (not an absolute
 * overlay) so it never corrupts `getTotalSize()` / `aria-rowcount` / scroll math.
 */
export type LoadMoreErrorStateProps = {
  onRetry?: () => void
  copy?: DataTableStateCopy
}

export const LoadMoreErrorState = ({ onRetry, copy }: LoadMoreErrorStateProps) => (
  <div
    className="flex items-center justify-center gap-3 border-t border-divider px-4 py-3 text-center"
    data-table-state="load-more-error"
  >
    <span className="text-sm text-error-main">
      {copy?.loadMoreErrorMessage ?? DEFAULT_LOAD_MORE_ERROR_MESSAGE}
    </span>
    {onRetry !== undefined && (
      <Button
        size="small"
        startIcon={<ArrowPathIcon />}
        variant="outlined"
        onClick={onRetry}
      >
        {copy?.loadMoreRetryLabel ?? DEFAULT_RETRY_LABEL}
      </Button>
    )}
  </div>
)
